import { ProviderStatus, useFlag, useOpenFeatureClientStatus } from "@openfeature/react-sdk";

export const useOpenFeatureFlag = (featureFlagKey: string) => {
  const { value, isError: flagHasError } = useFlag(featureFlagKey, false);
  const providerStatus = useOpenFeatureClientStatus();

  const isStarting = providerStatus === ProviderStatus.NOT_READY;
  const isUpdatingContext = providerStatus === ProviderStatus.RECONCILING;

  // Return false while OpenFeature starts or updates flags after a user/shop change.
  if (isStarting || isUpdatingContext) {
    return { value: false, loading: true, error: false };
  }

  const providerHasError =
    providerStatus === ProviderStatus.ERROR || providerStatus === ProviderStatus.FATAL;

  return {
    value,
    loading: false,
    error: providerHasError || flagHasError
  };
};
